<template lang="pug">
  v-content(class="fundo")
    v-container(fluid class="bloco_imagem_topo")
      v-layout(row wrap)
        v-img(:src="require('../assets/sala2.jpg')" class="imagens_topo" max-height="380")
          span(class="labelpic") </br>&nbsp&nbsp&nbsp&nbsp ADVOGADOS
      v-layout(row wrap class="scrollfundo")           
        v-flex(xs1)
        v-flex(xs4)
          v-card(flat)
            br
            v-card-text(class="texto_titulo") ADVOGADOS
            span(class="separator3")
            v-list
              v-list-tile(v-for="item in areas" :key="item.id")
                v-list-tile-content                  
                  v-btn(flat class="menu_cidades" @click.native="onChangeArea(item.id)") {{ item.title1 }}
        v-flex(xs6)
          v-card(flat)
            p
            br
            p
            v-card-text(class="texto_titulo" v-html="currentTitle")
            v-card-text(class="advogados" v-html="currentText")
            p
            v-card-text(class="texto_titulo" v-html="currentTitle1")
            v-card-text(class="texto1" v-html="currentAddress")
            p
            v-img(v-if="currentArea==1" :src="require('../assets/lisbon_location_img.png')" class="" max-width="800")
            v-img(v-if="currentArea==2" :src="require('../assets/porto_location_img.png')" class="" max-width="800")
            p </br>
            v-btn(class="botao" flat v-on:click="$emit('onChangeComponent','contactos')") Fale connosco &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
            p </br>
        v-flex(xs1)

    v-footer(class="footer400")
      v-flex(xs12)
        v-layout(justify-center row wrap)
          v-layout(justify-center row wrap)
            v-btn(flat v-for="item in menu" :key="item.id" v-on:click="$emit('onChangeComponent',item.comp)" class="footerlinks") {{ item.title }}
        v-layout(justify-center row wrap)
        v-layout(justify-center row wrap)
          v-flex(xs1)
          v-flex(xs3)
            v-layout(justify-center row wrap)        
              p
              br
              p(class="texto_fundo2") </br></br></br>© 2019 Luis S. Rodrigues & Associados. All Rights Reserved.      
          v-flex(xs8)        
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<script>
  export default {
    name: 'advogados',
    data: () => ({
      currentArea: 1,
      currentTitle1: 'Lisboa',
      currentTitle: 'Advogados',
      currentText: 'Luis S. Rodrigues</br></br>'
            + 'Eloy Rodrigues</br></br>'
            + 'Vasco Cunha</br></br>'
            + 'Helena Barroso</br></br>'
            + 'Manuel Carvalho</br></br>'
            + 'Andreia Serrão</br></br>'
            + 'Ana Margarida Paulo</br></br>'
            + 'Joana Rodrigues de Almeida</br></br>'
            + 'João Leite Santos (advogado estagiário)</br></br>'
            + 'Rita Correia Nunes (advogada estagiária)</br></br>',
      currentAddress: 'Luís S Rodrigues & Associados-  Sociedade de Advogados </br></br>Campo Grande 28,6º-A </br>1700-093 LISBOA ( Alvalade )',
      menu: [    
        { id: '1', title: 'Apresentação', comp: 'apresentacao'},
        { id: '2', title: 'Áreas de Actividade', comp: 'areas_actividade'},
        { id: '3', title: 'Advogados', comp: 'advogados'},
        { id: '4', title: 'Contactos', comp: 'contactos'}         
      ],
      areas:[
        { id: '1', title1: 'Lisboa', title: 'Advogados', text: 'Luis S. Rodrigues</br></br>'
            + 'Eloy Rodrigues</br></br>'
            + 'Vasco Cunha</br></br>'
            + 'Helena Barroso</br></br>'
            + 'Manuel Carvalho</br></br>'
            + 'Andreia Serrão</br></br>'
            + 'Ana Margarida Paulo</br></br>'
            + 'Joana Rodrigues de Almeida</br></br>'
            + 'João Leite Santos (advogado estagiário)</br></br>'
            + 'Rita Correia Nunes (advogada estagiária)</br></br>',
            address: 'Luís S Rodrigues & Associados-  Sociedade de Advogados </br></br>Campo Grande 28,6º-A </br>1700-093 LISBOA ( Alvalade )'},
        { id: '2', title1: 'Porto', title: 'Advogados', text: 'Elisa Morais</br></br>'
            + 'Elisabete Patrício</br></br>',
            address: 'Luís S Rodrigues & Associados-  Sociedade de Advogados </br></br>Praça do Bom Sucesso, 61 -604 </br>4150-146 Porto'}
      ],      
    }),

   methods: {
    onChangeArea(area){
      this.currentArea = area
      this.currentTitle = this.areas[area-1].title
      this.currentTitle1 = this.areas[area-1].title1
      this.currentText = this.areas[area-1].text
      this.currentAddress = this.areas[area-1].address
    },
   },

   mounted: function () {
         this.$nextTick(function () {
            window.scrollTo(0, 0)
         })
    }


  }
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<style>
</style>